// @flow
import React from 'react';
import DefaultTheme from './theme';
import Tooltip from '../tooltip';
export var InfoBubbleTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { TooltipPosition } from '../tooltip';
import type { TooltipThemeType } from '../tooltip/theme';

export type InfoBubbleThemeType = {
  TooltipReference: * => Node,
  InfoIcon: * => Node,
  InfoBubbleTooltipTheme: TooltipThemeType,
}

type Props = {|
  children: Node;
  tooltipPosition?: TooltipPosition;
  theme?: InfoBubbleThemeType;
|}
*/

var InfoBubble = function InfoBubble(_ref
/*: Props */
) {
  var children = _ref.children,
      _ref$tooltipPosition = _ref.tooltipPosition,
      tooltipPosition = _ref$tooltipPosition === void 0 ? 'right' : _ref$tooltipPosition,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;
  return /*#__PURE__*/React.createElement(theme.TooltipReference, {
    "data-test": "info-bubble"
  }, /*#__PURE__*/React.createElement(theme.InfoIcon, {
    "data-test": "info-bubble-icon"
  }), /*#__PURE__*/React.createElement(Tooltip, {
    visible: true,
    tooltipPosition: tooltipPosition,
    theme: theme.InfoBubbleTooltipTheme
  }, children));
};

export default InfoBubble;